<template>
  <section>
    <Nav :step="sectorFromState.inAppStep"
         @goToLocation="goToLocation"
         @goToBase="goToBase"
         @goToInsulation="goToInsulation"
         @goToDampCourse="goToDampCourse"
         @goToMinorResult="goToMinorResult"
         @addFromNav="addFromNav"
         ref="Nav"/>
    <div class="container">
      <div class="row">
        <div class="minor__title minor__title-btn">
          Параметры участка кровли
          <DeleteBtn v-if="sectors.length > 1"
                     @showDeleteConfirmation="showDeleteConfirmation"/>
        </div>
        <div class="common__pane">
          <div class="common__title sector__title sector__title-top" @click="qwe()">
            Размеры участка
          </div>
          <div class="params">
            <div class="params__inputs">
              <div class="params__inputs-sizes">
                <div class="params__inputs-item">
                  <span class="label">Высота<br> здания h, м</span>
                  <input type="number"
                         class="input"
                         v-model.number="sectorFromState.height"
                         @input="updateSectorHeight"
                         min="0"
                         max="100"
                         step="0.1">
                </div>
                <div class="params__inputs-item">
                  <span class="label">
                    Сторона<br> b, м
                  </span>
                  <input type="number"
                         class="input"
                         :value="sectorFromState.sideB"
                         @input="updateSectorSideB"
                         @change="updateSectorImage"
                         min="0"
                         max="1000"
                         step="0.1">
                </div>
                <div class="params__inputs-item">
                  <span class="label">
                    Сторона<br> l, м
                  </span>
                  <input type="number"
                         class="input"
                         :value="sectorFromState.sideL"
                         @input="updateSectorSideL"
                         @change="updateSectorImage"
                         min="0"
                         max="1000"
                         step="0.1">
                </div>
              </div>
              <input type="text"
                     class="input input__name"
                     :value="sectorFromState.sectorName"
                     @change="updateSectorName">
            </div>
            <div class="params__figure">
              <Figure ref="figure" :defaultSvgParams="defaultSvgParams"/>
            </div>
          </div>
        </div>
        <div class="common__pane similar__pane">
          <div class="common__title sector__title">Количество аналогичных участков</div>
          <div class="sectorsCount">
            <button @click="sectorFromState.sectorsCount -= 1; updateSectorsCount()"
                    class="common__plusMinus-button"
                    :disabled="sectorFromState.sectorsCount === 1">
              <img src="@/assets/img/minus.svg" alt="-">
            </button>
            <input type="number"
                   class="common__plusMinus-input"
                   v-model.number="sectorFromState.sectorsCount"
                   @change="updateSectorsCount">
            <button @click="sectorFromState.sectorsCount += 1; updateSectorsCount()"
                    class="common__plusMinus-button">
              <img src="@/assets/img/plus.svg" alt="+">
            </button>
          </div>
        </div>
        <div class="buttons__nav wizard__buttons-nav">
          <button @click="goToDampCourse"
                  class="common__button-prev">
            <img src="@/assets/img/common-arrow-prev.svg" alt="←">
            <span>Гидроизоляция</span>
          </button>
          <button @click="goToMinorResult"
                  :disabled="sectorFromState.height <= 0"
                  class="common__button-next special">
            Промежуточный расчет
            <img src="@/assets/img/common-arrow-next.svg" alt="→">
          </button>
        </div>
        <div class="wizard__buttons-nav--result">
          <button class="common__button-result" @click="addSector"
                  :disabled="sectorFromState.height <= 0">
            <img src="@/assets/img/big-plus.svg" alt="+">
            Добавить новый участок
          </button>
          <div class="text">
            Параметры текущего участка сохранятся и добавятся в общий расчет
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import { mapState, mapMutations } from 'vuex';
import { dataLayerPushEvent } from '@/utils/GTM';
import Figure from '@/components/Figure.vue';
import Nav from '@/components/Nav.vue';
import DeleteBtn from '@/components/DeleteBtn.vue';

export default {
  data() {
    return {
    };
  },
  components: {
    Figure,
    Nav,
    DeleteBtn,
  },
  methods: {
    ...mapMutations({
      UPDATE_SECTOR_PARAM: 'UPDATE_SECTOR_PARAM',
      CLEAR_SECTOR_MATERIAL_SIZE_PARAMS: 'CLEAR_SECTOR_MATERIAL_SIZE_PARAMS',
    }),
    updateSectorSideB(e) {
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(e.target.valueAsNumber)) {
        this.UPDATE_SECTOR_PARAM({
          id: this.sectorId,
          param: 'sideB',
          val: e.target.valueAsNumber,
        });
        if (this.isClearNeed) {
          this.CLEAR_SECTOR_MATERIAL_SIZE_PARAMS(this.sectorId);
        }
      }
    },
    updateSectorSideL(e) {
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(e.target.valueAsNumber)) {
        this.UPDATE_SECTOR_PARAM({
          id: this.sectorId,
          param: 'sideL',
          val: e.target.valueAsNumber,
        });
        if (this.isClearNeed) {
          this.CLEAR_SECTOR_MATERIAL_SIZE_PARAMS(this.sectorId);
        }
      }
    },
    updateSectorHeight() {
      this.UPDATE_SECTOR_PARAM({
        id: this.sectorId,
        param: 'height',
        val: this.sectorFromState.height,
      });
      if (this.isClearNeed) {
        this.CLEAR_SECTOR_MATERIAL_SIZE_PARAMS(this.sectorId);
      }
    },
    updateSectorsCount() {
      this.UPDATE_SECTOR_PARAM({
        id: this.sectorId,
        param: 'sectorsCount',
        val: this.sectorFromState.sectorsCount,
      });
      if (this.isClearNeed) {
        this.CLEAR_SECTOR_MATERIAL_SIZE_PARAMS(this.sectorId);
      }
    },
    updateSectorName(e) {
      this.UPDATE_SECTOR_PARAM({
        id: this.sectorId,
        param: 'sectorName',
        val: e.target.value,
      });
    },
    updateSectorImage() {
      this.UPDATE_SECTOR_PARAM({
        id: this.sectorId,
        param: 'sectorImage',
        val: btoa(this.$refs.figure.$refs.figureCode.outerHTML),
      });
    },
    showDeleteConfirmation() {
      this.$emit('showDeleteConfirmation');
    },
    goToLocation() {
      this.$emit('goToLocation');
    },
    goToBase() {
      this.$emit('goToBase');
    },
    goToInsulation() {
      this.$emit('goToInsulation');
    },
    goToDampCourse() {
      this.$emit('goToDampCourse');
    },
    goToMinorResult() {
      dataLayerPushEvent('calc-roofload-step6');
      this.$emit('goToMinorResult');
    },
    addFromNav() {
      this.$emit('addFromNav');
    },
    addSector() {
      this.$emit('addSector');
    },
  },
  mounted() {
    if (this.sectorFromState.sectorImage === '') {
      this.updateSectorImage();
    }
  },
  computed: {
    ...mapState({
      defaultSvgParams: state => state.defaultSvgParams,
      sectors: state => state.sectors,
    }),
    sectorId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    sectorFromState() {
      return this.$store.getters.getSector(this.sectorId);
    },
    isClearNeed() {
      return this.sectorFromState.material.size.C !== ''
        || this.sectorFromState.material.size.D !== ''
        || this.sectorFromState.material.size.E !== '';
    },
  },
};
</script>
<style lang="sass">
  .sector
    &__title
      padding: 0
      +media((margin-bottom: (320: 0, 768: rem(-20))))
      +media((text-align: (320: center, 768: left)))
      &-top
        padding-bottom: rem(32)
      &.common__title
        padding: 0
  .params
    grid-template-columns: 7fr 15fr
    +media((display: (320: flex, 768: grid)))
    flex-direction: column
    &__figure
      +media((order: (320: 1, 768: 2)))
      svg
        max-width: 100%
        height: auto
    &__inputs
      +media((order: (320: 2, 768: 1)))
      display: flex
      justify-content: center
      +media((text-align: (320: center, 768: left)))
      +media((padding-right: (320: 0, 768: rem(40))))
      flex-direction: column
      &-sizes
        display: flex
        +media((justify-content: (320: center, 768: flex-start)))
        +media((flex-direction: (320: row, 768: column)))
      &-item
        display: flex
        align-items: center
        justify-content: space-between
        +media((flex-direction: (320: column, 768: row)))
        +media((padding: (320: rem(32) 0 rem(8), 768: rem(8) 0)))
        &:first-of-type
          .input
            +media((border-radius: (320: rem(4) 0 0 rem(4), 768: rem(4))))
        &:nth-child(2)
          .input
            +media((border-radius: (320: 0, 768: rem(4))))
        &:last-of-type
          .input
            +media((border-radius: (320: 0 rem(4) rem(4) 0, 768: rem(4))))
        .label
          font-style: normal
          font-weight: 500
          font-size: rem(14)
          line-height: rem(18)
          color: #5C5C5C
          +media((order: (320: 2, 768: 1)))
          +media((font-size: (320: rem(12), 768: rem(14))))
          +media((padding-top: (320: rem(10), 768: 0)))
          +media((padding-right: (768: rem(20), 992: 0)))
          br
            +media((display: (320: inline-block, 768: none)))
        .input
          background: #FFFFFF
          border: rem(1) solid $grey
          box-sizing: border-box
          font-family: $main-font
          text-align: center
          font-style: normal
          font-weight: 600
          font-size: rem(18)
          line-height: rem(22)
          color: #1C1C1B
          outline: none
          transition: .5s
          +media((height: (320: rem(40), 768: rem(52))))
          +media((width: (320: rem(90), 768: rem(80))))
          +media((order: (320: 1, 768: 2)))
          &:hover, &:focus
            @extend .common__input-hover
          &__name
            width: 100%
            text-align: left
      .input
        &__name
          background: #FFFFFF
          border: rem(1) solid $grey
          box-sizing: border-box
          font-family: $main-font
          font-style: normal
          font-weight: 500
          font-size: rem(14)
          line-height: rem(18)
          color: #5C5C5C
          outline: none
          transition: .5s
          border-radius: rem(4)
          padding: 0 rem(20)
          text-align: left
          margin: rem(8) auto 0
          +media((height: (320: rem(40), 768: rem(52))))
          +media((width: (320: rem(270), 768: 100%)))
          &:hover, &:focus
            @extend .common__input-hover
  .sectorsCount
    display: flex
    flex-direction: row
    align-items: center
  .similar
    &__pane
      margin-top: rem(34)
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      .sector__title
        margin: 0
        text-align: left
        +media((font-size: (320: rem(13), 768: rem(18))))
        +media((line-height: (320: rem(21), 768: rem(24))))
  .wizard
    &__buttons
      &-nav
        &--result
          width: 100%
          display: flex
          flex-direction: column
          margin-top: rem(-34)
          padding-bottom: rem(51)
          +media((align-items: (320: flex-start, 430: flex-end)))
          .text
            font-style: normal
            font-weight: 500
            font-size: rem(12)
            line-height: rem(20)
            color: #5C5C5C
            text-align: left
            padding-top: rem(17)
            max-width: rem(320)
            +media((width: (320: calc(100% - 48px), 430: rem(320), 576: rem(300), 768: rem(320))))
            +media((margin-left: (320: rem(24), 430: 0)))
            +media((margin-right: (430: rem(24), 768: 0)))
  </style>
